// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".category-ad-view .category-ad-group .category-ad-img{width:100%}", ""]);
// Exports
module.exports = exports;
